// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {DuplicateOp} from './duplicate-op.js'

export class DuplicateOpReport {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): DuplicateOpReport {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsDuplicateOpReport(bb: flatbuffers.ByteBuffer, obj?: DuplicateOpReport): DuplicateOpReport {
    return (obj || new DuplicateOpReport()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsDuplicateOpReport(
    bb: flatbuffers.ByteBuffer,
    obj?: DuplicateOpReport
  ): DuplicateOpReport {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new DuplicateOpReport()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  duplicates(index: number, obj?: DuplicateOp): DuplicateOp | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset
      ? (obj || new DuplicateOp()).__init(this.bb!.__vector(this.bb_pos + offset) + index * 24, this.bb!)
      : null
  }

  duplicatesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
  }

  static startDuplicateOpReport(builder: flatbuffers.Builder) {
    builder.startObject(1)
  }

  static addDuplicates(builder: flatbuffers.Builder, duplicatesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, duplicatesOffset, 0)
  }

  static startDuplicatesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(24, numElems, 8)
  }

  static endDuplicateOpReport(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 4) // duplicates
    return offset
  }

  static createDuplicateOpReport(
    builder: flatbuffers.Builder,
    duplicatesOffset: flatbuffers.Offset
  ): flatbuffers.Offset {
    DuplicateOpReport.startDuplicateOpReport(builder)
    DuplicateOpReport.addDuplicates(builder, duplicatesOffset)
    return DuplicateOpReport.endDuplicateOpReport(builder)
  }
}
